import { render, staticRenderFns } from "./StandardDocuments.vue?vue&type=template&id=1839abc4"
import script from "./StandardDocuments.vue?vue&type=script&lang=js"
export * from "./StandardDocuments.vue?vue&type=script&lang=js"
import style0 from "./StandardDocuments.vue?vue&type=style&index=0&id=1839abc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports